import { Injectable } from '@angular/core';
import { IPaetepCfGenericMapperService } from '../../interfaces/paetep-cf-generic-mapper.service';
import { CalculateAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/calculate-answer-config.model';
import { EdlCfCalculateModel, EdlCfCalculationOperations, EdlCfGenericModel, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { CustomFormUserFormDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-user-form-display-dto.model';
import { CustomFormQuestionType } from 'src/app/model/enum/observations/custom-forms/custom-form-question-type.enum';
import { CustomFormsHelpersService } from '../../custom-forms-helpers/custom-forms-helpers.service';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfCalculatorMapperService implements IPaetepCfGenericMapperService<CalculateAnswerConfig, EdlCfCalculateModel> {

    constructor(private customFormHelpers: CustomFormsHelpersService) { }

    public toEdlModel = (child: CustomFormQuestionDisplayDTO<CalculateAnswerConfig>, observationDetails?: CustomFormUserFormDisplayDTO): EdlCfCalculateModel => {
        return {
            title: child.label,
            operation: EdlCfCalculationOperations.SUM,
            linkedQuestionIDs: child.answerConfig?.optionValues ?? [],
            shouldFilterInvalidInputs: !!observationDetails?.completed
        }
    }

    public toPaetepModel = ({
        formID, 
        sectionID,
        displayOrder,
        groupOrder,
        question
    } : {
        formID: string, 
        sectionID: string, 
        displayOrder: number,
        groupOrder: number,
        question: EdlCfGenericModel<EdlCfCalculateModel>
    }): CustomFormQuestionDisplayDTO<CalculateAnswerConfig> =>  {
        return this.customFormHelpers.createCustomFormQuestion<CalculateAnswerConfig>({
            $type: CustomFormQuestionType.CALCULATOR,
            typeID: CustomFormQuestionType.CALCULATOR,
            formID,
            sectionID,
            questionID: question?.id ?? '',
            readOnly: false,
            required: false,
            displayOrder,
            groupOrder,
            label: (question?.config?.title ?? '').substring(0, MAX_TITLE_LENGTH),
            displayLabel: true,
            answerConfig: {
                optionValues: question.config.linkedQuestionIDs
            }
        });
    }
}
